function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { PureComponent } from 'react'; // original author: gago

import PropTypes from 'prop-types';
import gettext from 'js-utils/gettext';
import classNames from 'classnames';
import isEmpty from 'lodash/isEmpty';
import getPaginationInfo from './lib';
import Button from '../button/Button';
import Icon from '../icon/Icon';
import ChevronLeftChunkySvg from '../iconography/icons/ChevronLeftChunky';
import ChevronRightChunkySvg from '../iconography/icons/ChevronRightChunky';
import SelectField from '../inputField/SelectField';
import { getSelectPropValues } from '../select/util';
import * as constants from './constants';

var Ellipsis = function Ellipsis(_ref) {
  var show = _ref.show;
  var component = null;

  if (show) {
    component = React.createElement("li", {
      className: "eds-l-mar-vert-2"
    }, React.createElement("span", null, "\u2026"));
  }

  return component;
};

var PaginationBound = function PaginationBound(_ref2) {
  var show = _ref2.show,
      _ref2$bound = _ref2.bound,
      bound = _ref2$bound === void 0 ? 1 : _ref2$bound,
      onSelected = _ref2.onSelected;
  var component = null;

  if (show) {
    component = React.createElement(PaginationPage, {
      isSelected: false,
      isDisabled: false,
      "data-spec": "page-bound-".concat(bound),
      onSelected: onSelected.bind(null, bound)
    }, React.createElement("span", {
      className: "eds-pagination__navigation-page__item eds-l-mar-vert-2 eds-l-mar-hor-2"
    }, bound));
  }

  return component;
};

var PaginationSummary = function PaginationSummary(_ref3) {
  var summary = _ref3.summary;
  var component = null;

  if (summary) {
    component = React.createElement("span", {
      "data-spec": "summary",
      className: "eds-text-bs eds-l-mar-2"
    }, summary);
  }

  return component;
};

var PaginationPages = function PaginationPages(_ref4) {
  var items = _ref4.items,
      onSelected = _ref4.onSelected,
      size = _ref4.size,
      pageCount = _ref4.pageCount;

  if ((size === constants.PAGE_SIZE_MIN || size === constants.PAGE_SIZE_CONTINUOUS) && items[0]) {
    var pageNum = items[0].number; // Continuous pagination varies slightly from Minimal as it only shows left/right
    // arrows and the current page. ex: `< 5 >`
    // Minimal shows left/right arrows and current page of total pages. ex: `< 5 of 9 >`

    if (size === constants.PAGE_SIZE_CONTINUOUS) {
      return React.createElement("li", {
        className: "eds-pagination__navigation-continuous eds-l-mar-hor-3",
        "data-spec": "eds-pagination__navigation-continuous"
      }, React.createElement("span", {
        className: "eds-text-color--control eds-text-weight--heavy"
      }, pageNum));
    }

    var gettextWithMarkup = {
      __html: gettext('<span class="eds-text-color--control eds-text-weight--heavy">%(pageNum)s</span> of %(pageCount)s', {
        pageNum: pageNum,
        pageCount: pageCount
      })
    };
    return (// eslint-disable-next-line react/no-danger
      React.createElement("li", {
        className: "eds-pagination__navigation-minimal eds-l-mar-hor-3",
        "data-spec": "eds-pagination__navigation-minimal",
        dangerouslySetInnerHTML: gettextWithMarkup
      })
    );
  }

  var pages = items.map(function (_ref5) {
    var number = _ref5.number,
        isSelected = _ref5.isSelected,
        isDisabled = _ref5.isDisabled;
    return React.createElement(PaginationPage, {
      key: number,
      isSelected: isSelected,
      isDisabled: isDisabled,
      "data-spec": "page-".concat(number),
      onSelected: onSelected.bind(null, number)
    }, React.createElement("span", {
      className: "eds-pagination__navigation-page__item eds-l-mar-vert-2 eds-l-mar-hor-2"
    }, number));
  });
  return React.createElement("li", null, React.createElement("ul", {
    className: "eds-pagination__navigation-pages"
  }, pages));
};

var PaginationPage = function PaginationPage(_ref6) {
  var isSelected = _ref6.isSelected,
      isDisabled = _ref6.isDisabled,
      onSelected = _ref6.onSelected,
      children = _ref6.children,
      dataSpec = _ref6['data-spec'],
      _ref6$show = _ref6.show,
      show = _ref6$show === void 0 ? true : _ref6$show,
      extraProps = _objectWithoutProperties(_ref6, ["isSelected", "isDisabled", "onSelected", "children", "data-spec", "show"]);

  var component = null;
  var className = classNames('eds-pagination__navigation-page', 'eds-fx--fade-in', {
    'eds-pagination__navigation-page--is-selected': isSelected,
    'eds-pagination__navigation-page--is-disabled': isDisabled
  });

  if (show) {
    component = React.createElement("li", {
      className: className,
      "data-spec": "".concat(dataSpec, "-wrapper")
    }, React.createElement(Button, _extends({
      style: "none",
      "data-spec": dataSpec,
      disabled: isDisabled,
      onClick: onSelected
    }, extraProps), children));
  }

  return component;
};

var ResultsPerPageSelect = function ResultsPerPageSelect(_ref7) {
  var resultsPerPage = _ref7.resultsPerPage,
      resultsPerPageOptions = _ref7.resultsPerPageOptions,
      onChange = _ref7.onChange,
      hasOnChange = _ref7.hasOnChange;

  if (!resultsPerPageOptions || !hasOnChange) {
    return null;
  }

  var values = getSelectPropValues(resultsPerPageOptions);
  var value = String(resultsPerPage);
  return React.createElement("div", {
    className: "eds-pagination__results-per-page-select",
    "data-spec": "pagination__results-per-page-select"
  }, React.createElement(SelectField, {
    values: values,
    value: value,
    label: gettext('Show'),
    onChange: onChange
  }));
};

var ResultsMessage = function ResultsMessage(_ref8) {
  var showResultsMessage = _ref8.showResultsMessage,
      totalNumResults = _ref8.totalNumResults,
      currentResultMin = _ref8.currentResultMin,
      currentResultMax = _ref8.currentResultMax;

  if (!totalNumResults || !showResultsMessage) {
    return null;
  }

  var resultsMsg = gettext('Results %(currentResultMin)s-%(currentResultMax)s of %(totalNumResults)s', {
    currentResultMin: currentResultMin,
    currentResultMax: currentResultMax,
    totalNumResults: totalNumResults
  });
  return React.createElement("div", {
    className: "eds-pagination__results-msg",
    "data-spec": "pagination__results-msg"
  }, resultsMsg);
};

var Pagination =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Pagination, _PureComponent);

  function Pagination(props) {
    var _this;

    _classCallCheck(this, Pagination);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Pagination).call(this, props));
    _this.state = {
      currentPage: props.pageNumber,
      currentResultsPerPage: props.resultsPerPage
    };
    return _this;
  }

  _createClass(Pagination, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(_ref9) {
      var pageNumber = _ref9.pageNumber,
          resultsPerPage = _ref9.resultsPerPage;
      var updatedProps = {};

      if (pageNumber !== this.state.currentPage) {
        updatedProps.currentPage = pageNumber;
      }

      if (resultsPerPage !== this.state.currentResultsPerPage) {
        updatedProps.currentResultsPerPage = resultsPerPage;
      }

      if (!isEmpty(updatedProps)) {
        this.setState(updatedProps);
      }
    }
  }, {
    key: "_handleSelected",
    value: function _handleSelected(pageNumber) {
      var _this$props = this.props,
          pageCount = _this$props.pageCount,
          onSelected = _this$props.onSelected;
      var currentPage = this.state.currentPage;

      if (pageNumber < 1 || pageNumber > pageCount || pageNumber === currentPage) {
        return;
      }

      this.setState({
        currentPage: pageNumber
      });
      onSelected(pageNumber);
    }
  }, {
    key: "_handleResultsPerPageChange",
    value: function _handleResultsPerPageChange(value) {
      var onResultsPerPageChange = this.props.onResultsPerPageChange;
      var intValue = parseInt(value, 10);
      this.setState({
        currentResultsPerPage: intValue,
        currentPage: 1
      });

      if (onResultsPerPageChange) {
        onResultsPerPageChange(intValue);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          currentPage = _this$state.currentPage,
          currentResultsPerPage = _this$state.currentResultsPerPage;
      var _this$props2 = this.props,
          resultsPerPageOptions = _this$props2.resultsPerPageOptions,
          totalNumResults = _this$props2.totalNumResults,
          showResultsMessage = _this$props2.showResultsMessage,
          onResultsPerPageChange = _this$props2.onResultsPerPageChange,
          pageCount = _this$props2.pageCount,
          size = _this$props2.size,
          summary = _this$props2.summary,
          showOnSinglePage = _this$props2.showOnSinglePage,
          style = _this$props2.style;
      var pageInfo = getPaginationInfo({
        pageNumber: currentPage,
        pageCount: pageCount,
        totalNumResults: totalNumResults,
        currentResultsPerPage: currentResultsPerPage,
        pageSize: size
      });
      var paginationClassName = classNames('eds-pagination', "eds-pagination--".concat(style));
      var paginationResultsClassName = classNames('eds-pagination__results', {
        'eds-pagination__results--has-results-per-page': onResultsPerPageChange,
        'eds-pagination__results--has-message': showResultsMessage
      });
      var paginationComponent = null;

      if (showOnSinglePage || pageInfo.pageCount > 1) {
        paginationComponent = React.createElement("div", {
          className: paginationClassName,
          "data-spec": "pagination"
        }, React.createElement("div", {
          className: paginationResultsClassName
        }, React.createElement("h2", {
          className: "eds-is-hidden-accessible"
        }, gettext('Pagination')), React.createElement(ResultsPerPageSelect, {
          resultsPerPage: currentResultsPerPage,
          resultsPerPageOptions: resultsPerPageOptions,
          onChange: this._handleResultsPerPageChange.bind(this),
          hasOnChange: onResultsPerPageChange
        }), React.createElement("ul", {
          className: "eds-pagination__navigation-group"
        }, React.createElement(PaginationPage, {
          isDisabled: pageInfo.isFirstPage,
          onSelected: this._handleSelected.bind(this, currentPage - 1),
          "data-spec": "page-prev"
        }, React.createElement("span", {
          className: "eds-pagination__navigation-page__arrow eds-l-mar-vert-2 eds-l-mar-hor-2"
        }, React.createElement(Icon, {
          type: React.createElement(ChevronLeftChunkySvg, null),
          title: gettext('Previous Page')
        }))), React.createElement(PaginationBound, {
          show: pageInfo.showPrevEllipsis,
          onSelected: this._handleSelected.bind(this)
        }), React.createElement(Ellipsis, {
          show: pageInfo.showPrevEllipsis
        }), React.createElement(PaginationPages, {
          items: pageInfo.pages,
          onSelected: this._handleSelected.bind(this),
          size: size,
          pageCount: pageInfo.pageCount
        }), React.createElement(Ellipsis, {
          show: pageInfo.showNextEllipsis
        }), React.createElement(PaginationBound, {
          show: pageInfo.showNextEllipsis,
          bound: pageInfo.pageCount,
          onSelected: this._handleSelected.bind(this)
        }), React.createElement(PaginationPage, {
          isDisabled: pageInfo.isLastPage,
          onSelected: this._handleSelected.bind(this, currentPage + 1),
          "data-spec": "page-next"
        }, React.createElement("span", {
          className: "eds-pagination__navigation-page__arrow eds-l-mar-vert-2 eds-l-mar-hor-2"
        }, React.createElement(Icon, {
          type: React.createElement(ChevronRightChunkySvg, null),
          title: gettext('Next Page')
        })))), React.createElement(ResultsMessage, {
          showResultsMessage: showResultsMessage,
          totalNumResults: totalNumResults,
          currentResultMin: pageInfo.currentResultMin,
          currentResultMax: pageInfo.currentResultMax
        })), React.createElement(PaginationSummary, {
          summary: summary
        }));
      }

      return paginationComponent;
    }
  }]);

  return Pagination;
}(PureComponent);

_defineProperty(Pagination, "propTypes", {
  /**
  * Callback function to be invoked on page size change.
  * Passing this prop also determines whether or not to show the resultsPerPageOptions dropdown.
  */
  onResultsPerPageChange: PropTypes.func,

  /**
  * Callback function to be invoked on select
  */
  onSelected: PropTypes.func.isRequired,
  pageCount: PropTypes.number,

  /**
  * Page number (will default/override internal state).
  * a.k.a. current page number
  */
  pageNumber: PropTypes.number,

  /**
  * The currently selected page size (will default/override internal state)
  */
  resultsPerPage: PropTypes.number,

  /**
  * Array of page sizes to show in dropdown ex: [20, 30, 40, 50]
  */
  resultsPerPageOptions: PropTypes.arrayOf(PropTypes.number),

  /**
  * Display a range message. ex: "Results 1-20 of 620".
  * Results message will only display when totalNumResults is also set.
  */
  showResultsMessage: PropTypes.bool,

  /**
   * How many page options to show at a given time.
   * Small currently maps to medium for backwards compatibility.
   * Minimal is equivalent to the spec for small.
   * (continuous, minimal, small, medium, large)
   */
  size: PropTypes.oneOf(constants.AVAILABLE_PAGE_SIZES),

  /**
  * Hide pagination if there is only a single page
  */
  showOnSinglePage: PropTypes.bool,

  /**
   * Changes the style (colour) of the active pagination number.
   * Available styles: organizer ($theme-control), consumer ($theme-primary-brand)
   */
  style: PropTypes.oneOf(constants.STYLES),

  /**
  * Description that appears below the page buttons
  */
  summary: PropTypes.node,

  /**
  * Total number of results.
  * Either totalNumResults or pageCount are required props.
  * Since the pageCount prop is on path to deprecation, using totalNumResults is recommended.
  */
  totalNumResults: constants.NUM_RESULTS_PROP_TYPE
});

_defineProperty(Pagination, "defaultProps", {
  resultsPerPageOptions: constants.DEFAULT_RESULTS_PER_PAGE_OPTIONS,
  resultsPerPage: constants.DEFAULT_RESULTS_PER_PAGE,
  pageNumber: 1,
  size: constants.DEFAULT_PAGE_SIZE,
  showOnSinglePage: true,
  style: constants.STYLE_ORGANIZER,
  showResultsMessage: false
});

export { Pagination as default };